let deferredPrompt: any;

// Helper to check if the device is iOS
const isIOS = () => {
    return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
};

// Helper to check if the app is already installed (standalone mode)
export const isStandalone = () => {
    return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
};

const showInstallPromotion = () => {
  const event = new CustomEvent('pwa-installavailable');
  window.dispatchEvent(event);
  console.log('PWA: Install promotion shown (event dispatched)');
};

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  showInstallPromotion(); 
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  console.log('PWA: App installed');
  window.dispatchEvent(new CustomEvent('pwa-installed'));
});

// Triggered by your "Download App" button
export const handleInstallClick = async () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`PWA: User response to install: ${outcome}`);
    deferredPrompt = null;
  } else if (isIOS()) {
    alert('To install this app on your iPhone: tap the share button (square with arrow) at the bottom and then select "Add to Home Screen"');
  } else {
    alert('Installation is only available when browsing from a supported mobile device or desktop browser. If you are on Chrome/Edge, check the address bar for the install icon, or use the browser menu.');
  }
};

// Auto-trigger the event if we are on mobile/iOS so the button shows up
// especially since iOS doesn't fire beforeinstallprompt
if (!isStandalone() && (isIOS() || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    // Small delay to ensure UI is ready
    setTimeout(() => {
        showInstallPromotion();
    }, 2000);
}